import type { FormSchema, GeneratorOptions } from '@cli-types/core-engine/schema.js'
import type { StepResult } from '@cli-types/next-adapter/forms.js'
import { isMultiStepForm } from '@core-engine/schema/field-helpers/form-fields/is-multi-step-form.js'
import { generateMultiStepForm } from './form-component-multistep/generate-multi-step-form.js'
import { generateSingleStepForm } from './form-component-single/generate-single-step-form.js'

export function generateFormComponent(
  schema: FormSchema,
  cwd: string,
  adminDir: string,
  options: GeneratorOptions
): StepResult {
  if (isMultiStepForm(schema) && schema.steps!.length > 1) {
    return generateMultiStepForm(schema, cwd, adminDir, options)
  }
  return generateSingleStepForm(schema, cwd, adminDir, options)
}
